import Link from "next/link";

const CommodityBlock = ({
  icon,
  name,
  items,
  imgWidth,
  mobileWidth,
  mobileHeight
}) => {
  return (
    <>
      {icon && (
        <div className="commodities-icon">
          <img src={icon} />
        </div>
      )}
      {name && <div className="commodities-name">{name}</div>}
      {items && <div className="commodities-name">{items}</div>}

      <style jsx>{`
        .commodities-icon {
          display: flex;
          justify-content: center;
          margin: 24px;
          align-items: center;
        }

        .commodities-icon img {
          max-width: 170px;
          width: ${imgWidth};
        }

        .commodities-name {
          font-size: 16px;
          margin: 0 16px;
          text-align: center;
          font-weight: bold;
        }

        .commodities-items {
          font-size: 14px;
          margin: 24px;
        }

        .commodities-blocks:hover {
          cursor: pointer;
          border: solid 1px var(--color-red);
        }
        @media only screen and (max-width: 600px) {
          .commodities-icon img {
            width: ${mobileWidth ? "100px" : ""};
            height: ${mobileHeight ? "100px" : ""};
          }
        }
      `}</style>
    </>
  );
};

type BlockComponentProps = {
  name?: string;
  items?: string;
  icon?: string;
  slug?: string;
  imgWidth?: string;
  minHeight?: string;
  mobileWidth?: boolean;
  mobileHeight?: boolean;
};

export const BlockComponent = ({
  name,
  items,
  icon,
  slug,
  imgWidth,
  minHeight,
  mobileWidth,
  mobileHeight
}: BlockComponentProps) => {
  return slug ? (
    <Link href={`/${slug}`} as={`/${slug}`}>
      <a className="commodities-blocks">
        <CommodityBlock
          name={name}
          items={items}
          icon={icon}
          imgWidth={imgWidth}
          mobileWidth={mobileWidth}
          mobileHeight={mobileHeight}
        />

        <style jsx>{`
          .commodities-blocks {
            max-width: 300px;
            width: 100%;
            height: 100%;
            min-height: ${minHeight ? minHeight : "250px"};
            margin-bottom: 24px;
            border-radius: 8px;
            background-color: var(--color-white);
            box-shadow: 0 4px 10px 0 rgba(64, 64, 64, 0.2);
            display: flex;
            justify-content: center;
            flex-direction: column;
            border: solid 1px var(--color-white);
          }
        `}</style>
      </a>
    </Link>
  ) : (
    <a className="commodities-blocks">
      <CommodityBlock
        name={name}
        items={items}
        icon={icon}
        imgWidth={imgWidth}
        mobileWidth={mobileWidth}
        mobileHeight={mobileHeight}
      />

      <style jsx>{`
        .commodities-blocks {
          max-width: 300px;
          width: 100%;
          height: 100%;
          min-height: ${minHeight ? minHeight : "250px"};
          margin-bottom: 24px;
          border-radius: 8px;
          background-color: var(--color-white);
          box-shadow: 0 4px 10px 0 rgba(64, 64, 64, 0.2);
          display: flex;
          justify-content: center;
          flex-direction: column;
          border: solid 1px var(--color-white);
        }
      `}</style>
    </a>
  );
};
